<template>
  <div>
<!--           v-model="selected"
      :show-select="totaleDati > 0" -->
    <v-data-table
      color="blue lighten-4"
      item-key="idx"
      :headers="headersFix"
      :items="datiMostrati"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      dense
      :footer-props="{
        itemsPerPageOptions: [10, 30, 50, -1]
      }"      
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialogAggiungi" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Aggiungi prodotto all'ordine</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="8" >
                      <component :is="'pProdotto'" :item="itemCodice()" :appoggio="editedItem" @change="componentValueChange"/>
                    </v-col>              
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItem.quantita" label="Pezzi" reverse></v-text-field>
                    </v-col>                        
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Annulla
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Salva
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>          
          <v-toolbar-title>Generazione degli ordini periodici e creazione Excel Ordine</v-toolbar-title>
          <v-subheader></v-subheader>
        </v-toolbar>
        <!-- <parametri :numeroRighe="datiRaw.length" @elabora="onElabora" @creaOrdine="onCreaOrdine" @aggiungiProdotto="dialogAggiungi = true"/> -->
        <parametri :numeroRighe="datiRaw.length" @elabora="onElabora" @creaOrdine="onCreaOrdine" @aggiungiProdotto="onAggiungiProdotto"/>
      </template>
      <template v-slot:no-data>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="deleteItem(item.idx)" title="Cancella il prodotto dall'ordine">mdi-delete</v-icon>
      </template>
      <template v-slot:[`item.descrizione`]="{ item }">
        <div>{{ `${(item.calc !== parseInt(item.pezzi) ? '*' : '')} ${item.descrizione}` }}</div>
      </template>
      <template v-slot:[`item.pezzi`]="{ item, index }">
        <v-edit-dialog
          :return-value.sync="item.pezzi"
          large
          persistent
          @save="aggiornaPezzi(item, index)"
        >
          <div class="teal--text">{{ `${item.pezzi} ${(item.calc !== parseInt(item.pezzi) ? '*' : '')}` }}</div>
          <template v-slot:input>
            <div class="mt-4 text-h6">
              Aggiorna numero pezzi
            </div>
            <v-text-field
              v-model="item.pezzi"
              :rules="[rules.numeropositivo]"
              label="Numero pezzi"
              single-line
              type="number"
              autofocus
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>    
    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione dall'ordine ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import excelService from '@/services/excelService'

  import Parametri from './parametri'
  import documenti from '@/services/documentiService'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import pProdotto from '@/views/drawer/elementi/prodotto'
  import tabacchi from '@/services/custom/tabacchiService.js'

  export default {
    components: {
      Parametri,
      pProdotto
    },
    mixins: [
      validazioni
    ],
    data () {
      return {
        dialogAggiungi: false,
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: {
          prodotto: {
            codice: '',
            descrizione: ''
          },
          quantita: 0
        },
        defaultItem: {
          prodotto: {
            codice: '',
            descrizione: ''
          },
          quantita: 0
        },
        filtri: null,
        tab: null,
        mostaRaw: false,
        datiRaw: [],
        datiModello: [],
        totaleDati: 0,
        intestazioniRaw: [],
        intestazioniModello: [],
        isimportaLetture: false,
        modelloItem: null,
        triggerReload: 0,
        triggerPulisci: 0,
        dialogDelete: false,
        headersFix: [
          { text: 'Codice', value: 'codice'},
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Categoria1', value: 'categoria1' },
          { text: 'Categoria2', value: 'categoria2' },
          { text: 'Categoria3', value: 'categoria3' },
          { text: 'Codice Forn.', value: 'codiceFornitore', align: 'end'},
          { text: 'Pezzi', value: 'pezzi', align: 'end'},
          { text: 'Chili', value: 'chili', align: 'end'},
          { text: 'Costo', value: 'costo', align: 'end'},
          { text: 'Giacenza', value: 'giacenza', align: 'end'},
          { text: 'Scorta Min', value: 'scortaMinima', align: 'end'},
          { text: 'Venduti', value: 'vendutoPeriodo', align: 'end'},
          { text: 'V/gg', value: 'VMG', align: 'end'},
          { text: 'Actions', value: 'actions'}
          // { text: '', value: 'data-table-expand' }
        ], 
        prodotto: '',
        infoParametri: null
      }
    },
    async mounted() {
    },
    computed: {
      datiMostrati() {
        return this.datiRaw
/*         console.log('dati mostrati')
        let dati = this.datiRaw
        dati = dati.map((x, idx) => { return { idx, ...x, calc: x.pezzi } })
        return dati */
      },
      headers() {
        return this.creaHeaders(this.intestazioniRaw)
      }
    },
    watch: {
      options: {
        async handler () {
          this.loading = false
        },
        deep: true
      }
    },
    methods: {
      onAggiungiProdotto(dati) {
        this.infoParametri = dati
        this.dialogAggiungi = true
      },
      close () {
        this.dialogAggiungi = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        const pr = this.prodotto
        const qta = parseFloat(this.editedItem.quantita)
        const p = await prodotti.getProdotto(pr)
        if (p) {
          let datiInfo = this.infoParametri
          datiInfo.idProdotto = p._id
          console.log(datiInfo)
          const info = await tabacchi.infoProdotto(datiInfo)
          const pesoConfezione = _.get(p, 'custom.tabacchi.pesoConfezione', 0) || 0
          const costoConfezione = _.get(p, 'custom.tabacchi.costo', 0) || 0
          const fabbisognoChili = +(qta * pesoConfezione).toFixed(4)
          const costo = +(qta * costoConfezione).toFixed(2)
          let nuovo = {
            codice: p._id,
            descrizione: p.descrizione,
            categoria1: _.get(p, 'statistici.categoria1.descrizione', ''),
            categoria2: _.get(p, 'statistici.categoria2.descrizione', ''),
            categoria3: _.get(p, 'statistici.categoria3.descrizione', ''),
            codiceFornitore: p.codice,
            pezzi: +qta.toFixed(0),
            chili: fabbisognoChili,
            costo: costo,
            pesoConfezione: pesoConfezione,
            costoConfezione: costoConfezione,
            giacenza: _.get(p, 'magazzino.giacenza', 0),
            scortaMinima: _.get(p, 'magazzino.scortaMinima', 0),
            vendutoPeriodo: info.vendutoPeriodo, // Calcolare
            VMG: info.VMG
          }
          nuovo.calc = 0 // (invece di nuovo.pezzi) In questo modo segna un asterisco anche sui prodotti nuovi
          const maxIdx = _.maxBy(this.datiRaw, 'idx')
          nuovo.idx = maxIdx.idx + 1
          this.datiRaw.push(nuovo)
        }
        this.dialogAggiungi = false
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.prodotto = value
      },      
      itemCodice() {
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "cercaEsterno": false,
          value: this.editedItem.prodotto.codice 
        }
      },    
      onElabora(dati) {
        this.datiRaw = dati
        this.intestazioniRaw = dati.length > 0 ? Object.keys(dati[0]) : []
        this.totaleDati = dati.length 
      },
      async onCreaOrdine(tipoOrdine, fornitore, fiscale) {
        const nomeFile = await configurazioni.getNumeratore('ordineTabacchi', true)
        const numeroOrdine = await configurazioni.getNumeratore(tipoOrdine, true)

        // Prende i dati dalla lista, crea Ordine + crea Excel + download automatico
        await this.creaOrdine(tipoOrdine, numeroOrdine, fornitore, fiscale, nomeFile)
        await this.creaExcel(nomeFile)
      },
      aggiornaPezzi(item, index) {
        // TODO: La variazione di prezzo dovrebbe essere calcolata dal server e non dal client ...
        const fabbisogno = item.pezzi
        const fabbisognoChili = +(fabbisogno * item.pesoConfezione).toFixed(4)
        const costo = +(fabbisogno * item.costoConfezione).toFixed(2)

        item.chili = fabbisognoChili
        item.costo = costo

        this.datiRaw[index] = item
      },
      creaHeaders(colonne, dati) {
        const hd = []
        // ---------------------------------------------------------
        // Eliminare le colonne non necessarie
        // ---------------------------------------------------------
        for (let c of colonne.filter(x => !['pesoConfezione', 'costoConfezione'].includes(x))) {
          const hh = { text: c, value: c }
          hd.push(hh)
        }
        hd.push({ text: 'Actions', value: 'actions'})
        // hd.push({ text: '', value: 'data-table-expand' })
        return hd
      },
      deleteItem (idx) {
        this.editedIndex = idx
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        const riga = this.datiRaw.find(x => x.idx === this.editedIndex)
        const index = this.datiRaw.indexOf(riga)
        this.datiRaw.splice(index, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async creaExcel(nomeFile) {
        const dati = this.datiRaw.map(x => {
          return {
            Codice: x.codiceFornitore,
            Quantità: x.chili
          }
        })
        await excelService.creaExcelData(dati, nomeFile + '.xls', ';', false)
      },
      async creaOrdine(tipoOrdine, numeroOrdine, fornitore, fiscale, nomeFile) {
        const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
        const tipoDocumento = tipi.find(x => x.codice === tipoOrdine)

        let doc = await documenti.getModello(tipoOrdine)

        doc._id = numeroOrdine
        doc.codice = numeroOrdine
        doc.data = new Date()
        doc.tipoDocumento = tipoDocumento
        fornitore.descrizione = fornitore.ragioneSociale
        delete fornitore.ragioneSociale
        doc.anagrafica = { fornitore: fornitore }
        doc.totali = {} // Verificare se serve
        doc.tipoDocumento.tabacchi = {
          nomeFile: nomeFile
        }

        for (let r of this.datiMostrati) {
          let riga = {
            rigaDescrittiva: false,
            descrizione: r.descrizione,
            quantita: r.pezzi, // r.chili,
            quantitaChili: r.chili,
            unitaMisura: {
              codice: 'pz',
              descrizione: 'pz'
            },            
/*             unitaMisura: {
              codice: 'kg',
              descrizione: 'kg'
            }, */
            prodotto: { codice: r.codice },
            tipoBene: 'PRODOTTO',
            valore: {
              acquisto: r.costoConfezione // TODO: verificare
            },
            costoTotale: r.costo
          }
          riga = { ...riga, ...fiscale }
          console.log(riga)
          doc.righe.push(riga)
        }
        console.log(doc)
        const result = await documenti.creaDocumento(doc)
        console.log(result)
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
